import { default as index0U4tsenlT8Meta } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/pages/index.vue")
  }
]